<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="bookingforms.icon" class="mr-1"></i>
            <span>{{ bookingforms.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">

            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-col cols="auto"> -->
                <b-form-group label-cols="12" label="Issued" label-size="sm">
                  <!-- :timePicker="true"
                      :timePicker24Hour="true" -->
                  <b-input-group>
                    <daterangepicker size="sm" ref="date" v-model="issued_at" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="false"
                      :single-date-picker="false">
                    </daterangepicker>
                    <!-- <daterangepicker size="sm" ref="date" v-model="date" :opens="'right'" :locale-data="locale_data"
                      :ranges="locale_ranges" :linkedCalendars="true" :single-date-picker="'range'">
                    </daterangepicker> -->
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="issued_at = {
                        startDate: null,
                        endDate: null,
                      }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Transaction Date From"
                  label-size="sm"
                >
                  <b-input-group>
                    <b-form-datepicker
                      size="sm"
                      v-model="datefrom"
                      label-help
                      hide-header
                      locale="en-GB"
                      placeholder="Transaction Date From"
                      :debounce="bookingforms.debounce"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                    ></b-form-datepicker>

                    <b-input-group-append>
                      <b-button
                        size="sm"
                        squared
                        variant="outline-secondary"
                        :disabled="!datefrom"
                        @click="datefrom = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Transaction Date To"
                  label-size="sm"
                >
                  <b-input-group>
                    <b-form-datepicker
                      size="sm"
                      v-model="dateto"
                      label-help
                      hide-header
                      locale="en-GB"
                      placeholder="Transaction Date To"
                      :debounce="bookingforms.debounce"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                    ></b-form-datepicker>

                    <b-input-group-append>
                      <b-button
                        size="sm"
                        squared
                        variant="outline-secondary"
                        :disabled="!dateto"
                        @click="dateto = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Status" label-size="sm">
                  <treeselect placeholder="Select status..." v-model="status" :clearable="true"
                    :options="status_options" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- :disabled="!user.permissions.includes('bookingforms.admin')" -->
                <b-form-group label-cols="12" label="Agent" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="agent" placeholder="Agent"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!agent" @click="agent = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Booking Type" label-size="sm">
                  <treeselect v-model="type" :clearable="true" :options="type_options"></treeselect>
                </b-form-group>
              </b-col> -->

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Payment Method" label-size="sm">
                  <treeselect v-model="payby" :clearable="true" :options="payby_options"></treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Supplier B/L" label-size="sm">
                  <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..." v-model="blac"
                    :clearable="true" :async="true" :load-options="treeselect_loadBLAC" :show-count="true"
                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                  <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                    :clearable="true" :async="true" :load-options="treeselect_loadSLAC" :show-count="true"
                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Your Ref/PO" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="yourref" :debounce="bookingforms.debounce"
                      placeholder="Your Ref/PO"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!yourref" @click="yourref = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..." v-model="event"
                    :clearable="true" :async="true" :load-options="treeselect_loadEvent" :show-count="true"
                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="RefNo ( Paste List )" label-for="referenceno" label-cols="12">
                  <b-input-group class="z-0">
                    <b-form-tags input-id="referenceno" v-model="referenceno" tag-variant="primary" separator=" ,;"
                      placeholder="Paste RefNo (333..,333...)" size="sm" class="h-29" add-button-text="+" add-on-change
                      remove-on-delete add-button-variant="outline-primary"></b-form-tags>

                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="referenceno = []">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-tooltip target="reflist1-tooltip" triggers="hover">Use ticket number in related fields? Check this
                  option to see
                  associated exchange and re-issued tickets.
                </b-tooltip>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Details" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="comments" :debounce="bookingforms.debounce"
                      placeholder="Details"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!comments" @click="comments = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="InvoiceNo ( Paste List )" label-for="invoiceno" label-cols="12">
                  <b-input-group class="z-0">
                    <b-form-tags input-id="invoiceno" v-model="invoiceno" tag-variant="primary" separator=" ,;"
                      placeholder="Paste InvoiceNo (IA626675,IA626674...)" size="sm" class="h-29" add-button-text="+"
                      add-on-change remove-on-delete add-button-variant="outline-primary"></b-form-tags>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="invoiceno = []">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="bookingforms" :selectall="bookingforms.selectall"
            :icon="bookingforms.icon" :busy="bookingforms.busy" :toolbarlibrary="bookingforms.toolbarlibrary"
            :tools="bookingforms.tools" :badges="bookingforms.badges" :fields="bookingforms.fields"
            :items="bookingforms.items" :offset="bookingforms.offset" :limit="bookingforms.limit"
            :downloaded="bookingforms.downloaded" :page="bookingforms.page" @load="bookingforms_load"
            @click="bookingforms_click" @changed="bookingforms_click('save', $event)" @select="bookingforms_select">
          </d-table>

        </div>
      </div>

      <div v-show="component">
        <component :is="component" :selection="bookingforms.selected"
          :config="bookingforms.action ? { action: bookingforms.action } : {}" @discard="bookingforms_click('discard')"
          @go="bookingforms_click('go')"></component>
      </div>
      <!-- <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-right">
            <b-button squared size="sm" variant="secondary" @click="$emit('discard')">
              <i class="fa fa-chevron-left pr-1"></i>Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer> -->
      <b-row class="px-3">
        <b-col>
          <b-alert :show="message ? true : false" variant="success">
            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
              <b-col>
                <span v-html="message"></span></b-col></b-row>
          </b-alert></b-col>
      </b-row>
    </b-card>
    <!-- <DraftInvoiceWizard :selection="bookingforms.selected" /> -->
  </div>
</template>


<script>
import gql from "graphql-tag";

import BookingFormEdit2 from "./Components/BookingFormEdit2";
import {
  candelete as bookingforms_candelete_rule,
  deletemessage as bookingforms_deletemessage_rule,
  deletetooltip as bookingforms_deletetooltip_rule,
  isadmin as bookingforms_isadmin_rule,
} from "./Components/bookingformsdelete";
// import BookingFormInvoice from "./Components/BookingFormInvoice";

// import DraftInvoiceWizard from "./Components/DraftInvoiceWizard";

export default {
  name: "BookingForms",
  components: {
    BookingFormEdit2,
    // BookingFormInvoicem,
    // DraftInvoiceWizard 
  },
  watch: {
    async issued_at() {
      await this.bookingforms_load(0);
    },
    async event() {
      await this.bookingforms_load(0);
    },
    async slac() {
      await this.bookingforms_load(0);
    },
    async payby() {
      await this.bookingforms_load(0);
    },
    async type() {
      await this.bookingforms_load(0);
    },
    async agent() {
      await this.bookingforms_load(0);
    },
    async status() {
      await this.bookingforms_load(0);
    },
    async yourref() {
      await this.bookingforms_load(0);
    },
    async comments() {
      await this.bookingforms_load(0);
    },
    async referenceno() {
      await this.bookingforms_load(0);
    },
    async invoiceno() {
      await this.bookingforms_load(0);
    },
  },
  data() {
    return {
      issued_at: {
        startDate: this.$moment().add(-3, 'M').startOf("month").format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      event: null,
      slac: null,
      blac: null,
      payby: null,
      payby_options: [],
      paybyreason: null,
      paybyreason_options: [],
      type: null,
      type_options: [],
      agent: null,
      yourref: null,
      comments: null,
      referenceno: [],
      invoiceno: [],
      status: null,
      status_options: [
        { id: "unsubmitted", label: "Unsubmitted" },
        { id: "submitted", label: "Submitted" },
        { id: "invoiced", label: "Invoiced" },
      ],
      criteria: {
        events: [],
      },
      message: null,
      bookingforms: {
        title: "Booking Forms",
        icon: "fa fa-tasks",
        debounce: 500,
        busy: false,
        denied: [],
        debounce: 500,
        page: 1,
        offset: 0,
        limit: 15,
        action: null,
        tools: "go,filter,download,clipboard,add,copy,edit,deleteconfirm,invoice,migrate",
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-repeat text-orange",
            position: "toolbar",
            action: "migrate",
            label: "Migrate",
            component: {
              name: "",
            },
          },
        ],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-35px",
          },
          {
            key: "referenceno",
            label: "RefNo",
            sortable: true,
          },
          {
            key: "issued_at",
            label: "Issued",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .format("DD/MM/YYYY HH:mm:ss");
              }
              return result;
            },
          },
          {
            key: "reason",
            label: "Type",
            sortable: true,
          },
          {
            key: "payby",
            label: "PayBy",
            sortable: true,
            class: "text-center",
          },

          // {
          //   key: "date",
          //   label: "Date",
          //   sortable: true,
          //   class: "text-center",
          //   formatter: (value, key, item) => {
          //     let result = "";
          //     if (value) {
          //       result = this.$moment.unix(value / 1000).format("DD/MM/YYYY");
          //     }
          //     return result;
          //   },
          // },
          {
            key: "blac",
            label: "BL A/C",
            sortable: true,
          },
          {
            key: "value",
            label: "Amount",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              }
            },
            totalled: true,
            total: 0,
          },
          {
            key: "event",
            label: "Event",
            sortable: true,
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
          },
          {
            key: "yourref",
            label: "Your Ref/PO",
            sortable: true,
          },
          {
            key: "comments",
            label: "Details",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 40) {
                  result = result.slice(0, 37) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "charge",
            label: "to Client £",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              }
            },
            totalled: true,
            total: 0,
          },
          {
            key: "status",
            label: "Status",
            sortable: true,
          },
          {
            key: "agent",
            label: "Agent",
            sortable: true,
          },
          {
            key: "invoiceno",
            label: "InvoiceNo",
            sortable: true,
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },

          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          {
            key: "reason",
            type: "badge",
            A: "primary",
            H: "danger",
            F: "primary",
             G: "dark",
            C: "warning",
            M: "secondary",
            V: "info",
            X: "dark",
            Y: "dark",
            Z: "dark",
            T: "info",
            O: "orange",
          },
          {
            key: "status",
            type: "badge",
            unsubmitted: "info",
            submitted: "danger",
            invoiced: "primary",
          },
        ],
        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  async mounted() {
    if (this.user.permissions.includes("bookingforms.admin")) {
      this.agent = null;
      this.status = "submitted";
    } else {
      this.agent = this.user.initials;
    }
    try {
      const response = await this.$apollo.query({
        query: gql`
            query setup_bookingformspaytypes($active:String) {
              setup_bookingformspaytypes(active: $active) {
                id: code
                label
                blac
                reasonrequired
              }
            }
          `,
        variables: { active: "1" }
      });
      this.payby_options = response.data.setup_bookingformspaytypes;
    } catch (error) {
      console.log(error);
    }

    // try {
    //   const response = await this.$apollo.query({
    //     query: gql`
    //         query setup_bookingformspayreasons {
    //           setup_bookingformspayreasons {
    //             id: code
    //             label
    //           }
    //         }
    //       `,
    //   });
    //   this.paybyreason_options = response.data.setup_bookingformspayreasons;
    //   // console.log(this.currency_options);
    // } catch (error) {
    // }

    try {
      const response = await this.$apollo.query({
        query: gql`
            query bookingformsreasontypes {
              bookingformsreasontypes {
                id
                label: name
              }
            }
          `,
      });
      this.type_options = response.data.bookingformsreasontypes;
    } catch (error) {
      console.log(error);
    }


    this.accessdenied();

    await this.bookingforms_load();
  },
  methods: {
    accessdenied() {
      this.bookingforms.denied = [];
      if (!this.user.permissions.includes("systems.development")) {
        this.bookingforms.denied.push("wizard");
      }
      if (!this.user.permissions.includes("systems.development")) {
        this.bookingforms.denied.push("migrate");
      }
      // Helpdesk 10750: Delete needs bookingforms.delete or bookingforms.admin,
      // same as the old Booking Forms screen
      if (
        !this.user.permissions.includes("bookingforms.delete") &&
        !this.user.permissions.includes("bookingforms.admin")
      ) {
        this.bookingforms.denied.push("deleteconfirm");
      }
    },
    // Helpdesk 10750: the delete rule lives in Components/bookingformsdelete.js, shared with
    // the Charges screen (Bhold list) so both grey out Delete the same way as the server.
    bookingforms_isadmin() {
      return bookingforms_isadmin_rule(this.user);
    },
    bookingforms_candelete(row) {
      return bookingforms_candelete_rule(row, this.user);
    },
    bookingforms_deletetooltip() {
      return bookingforms_deletetooltip_rule(this.user);
    },
    bookingforms_deletemessage(ss) {
      // Delete is hidden altogether without the permission, so no message either
      if (this.bookingforms.denied.includes("deleteconfirm")) {
        return null;
      }
      return bookingforms_deletemessage_rule(ss, this.user);
    },
    async bookingforms_load(offset, limit, page) {

      let state = this.bookingforms

      this.message = null

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      if (limit != 0) { state.busy = true; }

      let variables = {
        offset: state.offset,
        limit: state.limit,
        mssql: true,
        issued_at: [
          this.issued_at.startDate
            ? this.$moment(this.issued_at.startDate).format("YYYY-MM-DD")
            : null,
          this.issued_at.endDate
            ? this.$moment(this.issued_at.endDate).format("YYYY-MM-DD")
            : null,
        ],
        event: this.event,
        slac: this.slac,
        blac: this.blac,
        payby: this.payby,
        reason: this.type,
        agent: this.agent,
        status: this.status,
        yourref: this.yourref,
        comments: this.comments,
        referenceno: this.referenceno.length > 0 ? this.referenceno.join(",") : null,
        invoiceno: this.invoiceno.length > 0 ? this.invoiceno.join(",") : null,
        dateformat: "DD/MM/YYYY"
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
              query bookingforms(
              $limit: Int
              $offset: Int
              $mssql: Boolean
              $referenceno: String
              $invoiceno: String
              $issued_at: [String]
              $event: String
              $slac: String
              $blac: String
              $payby: String
              $reason: String
              $agent: String
              $status: String
              $yourref: String
              $comments: String        
              ) {
                bookingforms(
                  limit: $limit
                  offset: $offset
                  mssql: $mssql
                  referenceno: $referenceno
                  invoiceno: $invoiceno
                  issued_at: $issued_at
                  event: $event
                  slac: $slac
                  blac: $blac
                  payby: $payby
                  reason: $reason
                  agent: $agent
                  status: $status
                  yourref: $yourref
                  comments: $comments
                ) {
                  id
                  referenceno                  
                  payby
                  reason
                  date
                  blac
                  value
                  currency
                  country
                  event
                  slac
                  charge
                  invoiceno
                  yourref
                  comments
                  status
                  agent
                  issued_at: modified
                  updated_by
                  updated_at
                  rows
                }
              }
            `,
          variables,
        });

        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.bookingforms
        } else {
          state.items = response.data.bookingforms;
        }


        // if (limit == 0) {
        //   state.selected = this.cleanit(response.data.bookingforms);
        // } else {
        //   state.items = []
        //   state.items = response.data.bookingforms;
        // }

      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async bookingforms_click(a, ss) {

      let state = this.bookingforms;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = this.state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.bookingforms_load(0, 0);
          break;

        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
        case "go":
          state.action = null;
          this.component = null;
          await this.bookingforms_load();
          break;
        // case "wizard":
        //   this.$bvModal.show("draftinvoices-wizard");
        //   break;
        case "add":
          this.component = "BookingFormEdit2";
          break;
        case "edit":
          this.component = "BookingFormEdit2";
          break;

        case "copy":
          state.action = "copy";
          this.component = "BookingFormEdit2";
          break;

        case "invoice":
          if (ss.length > 0) {
            if (ss[0].invoiceno) {
              this.message = null
              this.component = "BookingFormInvoice";
            } else {
              this.message = "Invoice has not been posted yet!"
              this.component = null;
            }
          }

          break;
        case "save":
          this.saveit(ss);
          break;

        case "delete":
          // Helpdesk 10750: belt and braces, the tool should already be disabled
          if (this.bookingforms.denied.includes("deleteconfirm")) {
            this.message = "<span class='text-danger'>You do not have permission to delete booking forms.</span>";
            break;
          }
          if (this.bookingforms_deletemessage(ss)) {
            this.message = this.bookingforms_deletemessage(ss);
            break;
          }
          this.deleteit(ss);
          break;

        case "migrate":
          this.bookingforms_migrateit(ss);
          break;
      }
    },
    async bookingforms_select(ss, tools) {

      let state = this.bookingforms;

      this.message = null

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "download", "wizard", "migrate", "clipboard"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit", "copy", "invoice"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1, and every selected row must be deletable (helpdesk 10750)
        let deletemessage = this.bookingforms_deletemessage(ss);
        let deletetooltip = this.bookingforms_deletetooltip();
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 && !deletemessage ? false : true;
            tool.tooltip = deletemessage ? deletetooltip : null;
          }
        });
        if (deletemessage) {
          this.message = deletemessage;
        }

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async saveit(ss) {

      this.busy = true;

      let variables = { rows: this.cleanit(ss) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation savebookingforms(
                $rows: [Bookingform_input]             
              ) {
                savebookingforms(rows: $rows) {
                  referenceno
                payby
                reason
                date
                blac
                value
                currency
                country
                event
                slac
                charge
                invoiceno
                yourref
                comments
                status
                agent
                issued_at: modified  
                }
              }
            `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async deleteit(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
        mutation bookingforms_delete(
          $rows: [Bookingform_input]
        ) {
          bookingforms_delete(rows: $rows) {
            id
          }
        }
      `,
          variables,
        });
      } catch (error) {
        console.log(error);
        // Helpdesk 10750: show the server's refusal. Load clears the message, so set it after.
        await this.bookingforms_load();
        this.message = "<span class='text-danger'>" + error.message + "</span>";
        return;
      }

      await this.bookingforms_load();
    },
    async bookingforms_migrateit(s) {
      console.log("importit", s);

      let state = this.bookingforms
      state.busy = true;

      let variables = {
        selected: [],
      };
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation bookingforms_migrate($selected: [Booking_input]) {
                bookingforms_migrate(selected: $selected) {
                  id
                }
              }
            `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      state.busy = false;

      await this.bookingforms_load(0);

    },
  },
};
</script>

<style></style>